import{a as i,b as c}from"./chunk-U3TQIHS4.js";import{e as t,m as r}from"./chunk-HBP5N4FR.js";function a(e){let n=i(e);return e.receiver===n?e.receiverAssets:void 0}var o=t(()=>{r();c()});export{a,o as b};
//# sourceMappingURL=chunk-2WP7OVEE.js.map
